import { render, staticRenderFns } from "./pcModule1.vue?vue&type=template&id=de9a3e98&scoped=true"
import script from "./pcModule1.vue?vue&type=script&lang=js"
export * from "./pcModule1.vue?vue&type=script&lang=js"
import style0 from "./pcModule1.vue?vue&type=style&index=0&id=de9a3e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de9a3e98",
  null
  
)

export default component.exports